import React, { FC } from 'react';
import { observer } from 'mobx-react';

import { AUTH_APP_NAME } from '../../constants';
import { SuspenseMicroApp, SuspenseMicroAppProps } from '../micro-app/suspense-micro-app';

export const AuthApp: FC<SuspenseMicroAppProps> = observer((props) => {
    if (!props.userStore.needLoadAuth) return null;

    return <SuspenseMicroApp {...props} appName={AUTH_APP_NAME} />;
});
